import PropTypes from "prop-types";
import { useState } from "react";

// Styles
import DialogButtonDivStyled from "components/elements/DialogButtonDivStyled";
import DialogButtonStyled from "components/elements/DialogButtonStyled";
import FormStyled from "components/forms/FormStyled";
import FormStyledError from "components/forms/FormStyledError";
// Utils
import { sortByLabel } from "utils/sorting";
// import filterList from "utils/filter-list";
import { isNotDeletedStatus } from "utils/filter-utils";

// Components
import SelectAll from "components/forms/SelectAllReactSelect";
import { FORM_LABEL } from "constants/brm";
import { AdminApi } from "features/brm";
import { LoadingSpinner as Loading } from "components/elements";
import { toast } from "react-hot-toast";
import getUniqueArray from "../../utils/get-unique-array";
// import customDetailStyle from "../../styles/react-select-styles";

function getReactSelectArray(array) {
  const objects = [];
  array.forEach((obj) => {
    objects.push({
      value: obj.id,
      label: obj.username,
    });
  });
  return objects.sort(sortByLabel);
}

export const AddWorkerForm = ({ setModalIsOpen, selectedElement, workerData }) => {
  // Dropdowns for forms
  const [postError, setPostError] = useState("");
  // const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const { mutateAsync: addProjectWorker } = AdminApi.useAddProjectWorker();

  // let filteredData = [];
  const { data: orgAttachedUsers } = AdminApi.useOrganizationAttachedUser({
    organizationId: selectedElement.organization,
  });

  const { data: orgUser } = AdminApi.useOrganizationUser({
    organizationId: selectedElement.organization,
  });

  const { data: readOnlyUsers } = AdminApi.useProjectReadOnlyUsers({
    projectId: selectedElement.id,
  });

  const handleSelectChange = (selectedItems) => {
    const items = selectedItems || [];
    setSelectedOptions(items);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (selectedOptions.length > 0) {
      Promise.all(
        selectedOptions.map((each) => {
          return addProjectWorker({ projectId: selectedElement.id, userId: each.value });
        })
      )
        .catch((error) => {
          if (error.status === 403) {
            toast.error(
              `Insufficient permissions to add user to the project. Error: ${error.status} ${error.statusText}`
            );
          } else {
            toast.error(
              `Error while attempting to add user to the project. Error: ${error.status} ${error.statusText}`
            );
          }
        })
        .finally(() => {
          setModalIsOpen(false);
        });
    } else {
      setPostError("*Please fill out all fields in the form prior to submitting.");
    }
  }

  if (orgAttachedUsers && orgUser && readOnlyUsers) {
    const result = [...orgAttachedUsers, ...orgUser];
    const uniqueUsersList = getUniqueArray(result, readOnlyUsers); // seperating users/workers list from read-only users
    const filteredList = getUniqueArray(uniqueUsersList, workerData).filter(isNotDeletedStatus); // filtering the list from exisiting data in the table and deleted users
    const options = getReactSelectArray(filteredList);

    return (
      <div id="WorkerAddForm">
        <form onSubmit={handleSubmit} action="" id="WorkerAddForm_form">
          <FormStyled>
            <div className="form-style" id="WorkerAddForm_input">
              <label id="WorkerAddForm_SelectUser">{FORM_LABEL.users}</label>
              <SelectAll
                // styles={customDetailStyle}
                isMulti
                options={options}
                defaultValue={selectedOptions}
                value={selectedOptions}
                onChange={handleSelectChange}
                allowSelectAll
                allOption={{
                  label: "Select all",
                  value: "*",
                }}
                elementId="WorkerAddForm"
              />
            </div>
          </FormStyled>
          <FormStyledError id="WorkerAddForm_error">{postError}</FormStyledError>
          <DialogButtonDivStyled id="WorkerAddForm_buttons">
            <DialogButtonStyled onClick={() => setModalIsOpen(false)} id="WorkerAddForm_cancelButton">
              Cancel
            </DialogButtonStyled>
            <DialogButtonStyled type="submit" id="WorkerAddForm_addButton">
              Add
            </DialogButtonStyled>
          </DialogButtonDivStyled>
        </form>
      </div>
    );
  }
  return <Loading />;
};

AddWorkerForm.propTypes = {
  selectedElement: PropTypes.shape({
    id: PropTypes.any,
    organization: PropTypes.any,
  }),
  setModalIsOpen: PropTypes.func,
  workerData: PropTypes.any,
};
